"use strict";

exports.__esModule = true;
exports.moveArrayItemBeforeTargetItem = exports.createToolbarTheme = exports.getHighestQualityVideo = void 0;

var _lodash = require("lodash");

var getHighestQualityVideo = function getHighestQualityVideo(videos) {
  var mp4 = videos.filter(function (video) {
    return video.format === 'mp4';
  });
  return mp4.reduce(function (result, video) {
    return parseInt(video.quality, 10) > parseInt(result.quality, 10) ? video : result;
  }, mp4[0]);
};

exports.getHighestQualityVideo = getHighestQualityVideo;

var createToolbarTheme = function createToolbarTheme(toolbarName, theme) {
  return (0, _lodash.mapKeys)(theme, function (value, key) {
    return "" + toolbarName + (0, _lodash.upperFirst)(key);
  });
};

exports.createToolbarTheme = createToolbarTheme;

var moveArrayItemBeforeTargetItem = function moveArrayItemBeforeTargetItem(arr, movedItemVal, targetItemVal) {
  var newArr = [].concat(arr);
  var movelItemIndex = newArr.indexOf(movedItemVal);

  if (movelItemIndex === -1) {
    return arr;
  }

  newArr.splice(movelItemIndex, 1);
  var targetItemIndex = newArr.indexOf(targetItemVal);

  if (targetItemIndex === -1) {
    return arr;
  }

  newArr.splice(targetItemIndex, 1, movedItemVal, targetItemVal);
  return newArr;
};

exports.moveArrayItemBeforeTargetItem = moveArrayItemBeforeTargetItem;